export class GoodbyePasswordsPageComponent {
  container;

  constructor() {
    this.container = document.querySelector('body.page-id-5254');
  }

  initialize() {
    this.addEventListeners();
  }

  addEventListeners() {
    window.addEventListener('message', event => {
      if (event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmit') {
        this.hsFormSubmitHandler(event.data);
      }
    });
  }

  hsFormSubmitHandler(data) {
    this.removeNewsletterSection();
  }

  removeNewsletterSection() {
    const newsletterSection = document.getElementById('newsletter-form');
    if (newsletterSection) {
      setTimeout(() => {
        newsletterSection.style.display = 'none';
      }, 500);
    }
  }
}